module.exports = __webpack_public_path__ + "static/img/chanping4.69b96ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/chanping4.jpg
// module id = Ky1J
// module chunks = 0